import { VendorStockInRequestDetailPage } from "@/features/vendor-app/pages/VendorStockInRequestDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/stock-in-request/$consignmentStockInRequestID",
)({
	component: VendorStockInRequestDetailPage,
});
